export function findActivities(slimmer, state) {
  return state.activities[slimmer.id]
}
